///@ts-check

import "./styles/index.scss"
import "COMMON/lib/delighters"
import "COMMON/src/override"

import { _ } from "COMMON/src/util"
import { setMoveTopHandler } from "COMMON/src/handler"

Delighters.config({ autoInit: false })

const main = async () => {
  setMoveTopHandler(_("a.for-top"))
}

document.addEventListener("DOMContentLoaded", main)
